<template>
  <div>
    <h3 class="mt-4 mb-1 subtitle-1">
      フィードバック
      <template v-if="mode == 'inspection'">
        <v-btn
          v-if="editFeedback == false"
          class="ml-2"
          color="primary"
          tile
          x-small
          outlined
          @click="startEditFeedback"
        >
          編集
        </v-btn>
        <v-btn
          v-if="editFeedback == true"
          class="ml-2"
          color="success"
          tile
          x-small
          outlined
          @click="updateFeedback"
        >
          保存
        </v-btn>
        <v-btn
          v-if="editFeedback == true"
          class="ml-2"
          color="warning"
          tile
          x-small
          outlined
          @click="editFeedback = false"
        >
          キャンセル
        </v-btn>
      </template>
    </h3>
    <p v-if="editFeedback == false" class="mt-2">
      <span v-if="inspection.feedback">
        <markdown-preview :source="inspection.feedback" />
      </span>
      <span v-else class="caption"> フィードバックがありません </span>
    </p>
    <v-textarea
      v-if="editFeedback == true"
      v-model="editableFeedback"
      autofocus
      class="body-2"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MarkdownPreview from '@/components/commons/MarkdownPreview'

export default {
  components: {
    MarkdownPreview
  },
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editFeedback: false,
      editableFeedback: ''
    }
  },
  computed: {
    ...mapState({
      mode: (state) => state.PostEditor.mode
    })
  },
  methods: {
    startEditFeedback () {
      this.editableFeedback = this.inspection.feedback
      this.editFeedback = true
    },
    updateFeedback () {
      const payload = {
        inspectionId: this.inspection.id,
        inspectionAttributes: {
          feedback: this.editableFeedback
        }
      }
      this.$store.dispatch('PostEditor/updateInspection', payload)
      this.editFeedback = false
    }
  }
}
</script>
